<div [class]="panelClass">
  <i class="material-icons mi-18 text-blue-light">info</i>
  <ng-content></ng-content>
</div>